<div [ngClass]="{'collapsed':sidebarCollapsed}" class="sidebar" fxFlexFill fxLayout="column"
	 fxLayoutAlign="start start">
	<div [ngClass]="{'collapsed':sidebarCollapsed}" class="sidebar-header" fxLayout="column"
		 fxLayoutAlign="start center">
		<div class="customer-logo">
			<app-logo-svg *ngIf="!companyLogo" [white]="user?.type === 'worker'"></app-logo-svg>
			<img *ngIf="companyLogo" alt="Company logo" src="{{companyLogo}}"/>
		</div>
		<div *ngIf="user?.type === 'inet' && user?.friendlyName" class="user-name">{{user?.friendlyName}}</div>
		<div *ngIf="user?.type === 'worker' && (user?.firstName || user?.lastName)" class="user-name">
			<span *ngIf="user?.firstName">{{user?.firstName}}</span>
			<span *ngIf="user?.firstName && user?.lastName">&nbsp;</span>
			<span *ngIf="user?.lastName">{{user?.lastName}}</span>
		</div>
		<mat-form-field *ngIf="user?.type === 'inet' && user?.username !== 'guestuser9999'" color="primary">
			<mat-select (selectionChange)="setSelectedCustomer()" [(value)]="currentCustomerId"
						[disabled]="user?.allowedCustomers?.length <= 1">
				<mat-option *ngFor="let c of user.allowedCustomers" [value]="c.id">
					{{c.id}} - {{c.name}}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field *ngIf="user?.type === 'worker'">
			<mat-select (selectionChange)="setSelectedDriver()" [(value)]="currentDriverId"
						[disabled]="user?.associatedDrivers?.length <= 1">
				<mat-option *ngFor="let c of user.associatedDrivers" [value]="c.id">
					{{c.id}} - {{c.firstName}} {{c.lastName}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<mat-nav-list class="scroll-container" fxFlexAlign="stretch">
      <ng-container *ngIf="user?.token">
        <a
          *ngFor="let page of pageKeys"
          [routerLinkActive]="['active']"
          [routerLink]="['/custom-page/' + page.name]"
          [state]="{url: page.url}"
          class="sidebar-link"
          fxLayout="row"
          fxLayoutAlign="start center"
          mat-button>
			<mat-icon>dashboard_customize</mat-icon>
			<span>{{page.name}}</span>
        </a>
      </ng-container>
        <a (click)="showWhatsNew()"
		   *ngIf="user?.type === 'inet' && user?.username !== 'guestuser9999' && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.whatsNewButton' | translate" class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center"
		   mat-button matTooltipPosition="after">
			<mat-icon>new_releases</mat-icon>
			<span>{{'mainNav.whatsNewButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'inet' && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
			[matTooltipDisabled]="!sidebarCollapsed"
			[matTooltip]="'mainNav.placeOrderButton' | translate"
			[routerLinkActive]="['active']" [routerLink]="['/place-order']"
			class="sidebar-link" fxLayout="row"
			fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>local_shipping</mat-icon>
			<span *ngIf="!overridePage; else overrideContent">{{ 'mainNav.placeOrderButton' | translate }}</span>
			<ng-template #overrideContent>
				<span>{{overridePage.name}}</span>
			</ng-template>
		</a>
		<a *ngIf="user?.type === 'inet' && user?.inetUser?.allowTrackOrder && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.trackOrderButton' | translate" [routerLinkActive]="['active']"
		   [routerLink]="['/track-order']" class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>track_changes</mat-icon>
			<span>{{'mainNav.trackOrderButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'inet' && user?.inetUser?.viewAccountReports && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.reportsButton' | translate" [routerLinkActive]="['active']"
		   [routerLink]="['/reports']" class="sidebar-link"
		   fxLayout="row" fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>assessment</mat-icon>
			<span>{{'mainNav.reportsButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'inet' && user?.inetUser?.viewRouteStops && user?.licenses?.xRouteEnabled && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.routeTrackingButton' | translate" [routerLinkActive]="['active']"
		   [routerLink]="['/route-tracking']" class="sidebar-link"
		   fxLayout="row" fxLayoutAlign="start center"
		   mat-button matTooltipPosition="after">
			<mat-icon>near_me</mat-icon>
			<span>{{'mainNav.routeTrackingButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'inet' && user?.username !== 'guestuser9999' && (user?.inetUser?.allowTrackOrder || user?.licenses?.xRouteEnabled) && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.trackParcelButton' | translate" [routerLinkActive]="['active']"
		   [routerLink]="['/track-parcel']" class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>next_week</mat-icon>
			<span>{{'mainNav.trackParcelButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'inet' && user?.inetUser?.allowAddressBookAccess && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.addressBookButton' | translate" [routerLinkActive]="['active']"
		   [routerLink]="['/address-book']" class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>book</mat-icon>
			<span>{{'mainNav.addressBookButton' | translate}}</span>
		</a>
		<a (click)="clearTemplateBookmark()"
		   *ngIf="user?.type === 'inet' && user?.allowRecentTemplates && selectedCustomer?.billingStatus !== 'CREDIT_HOLD'"
		   [matTooltipDisabled]="!sidebarCollapsed" [matTooltip]="'mainNav.orderTemplatesButton' | translate"
		   [routerLinkActive]="['active']"
		   [routerLink]="['/order-templates']" class="sidebar-link"
		   fxLayout="row" fxLayoutAlign="start center"
		   mat-button matTooltipPosition="after">
			<mat-icon>star</mat-icon>
			<span>{{'mainNav.orderTemplatesButton' | translate}}</span>
		</a>
		<a *ngIf="user?.token && user?.type === 'inet' && user?.globalSettings?.displayInvoices && user?.inetUser?.viewInvoices"
		   [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.invoicesButton' | translate" [routerLinkActive]="['active']"
		   [routerLink]="['/invoices']" class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>monetization_on</mat-icon>
			<span>{{'mainNav.invoicesButton' | translate}}</span>
		</a>
		<a *ngIf="user?.token && ((user?.type === 'inet' && user?.canViewOwnProfile && selectedCustomer?.billingStatus !== 'CREDIT_HOLD') || user?.type === 'worker')"
		   [matTooltipDisabled]="!sidebarCollapsed" [matTooltip]="'User Profile'"
		   [routerLinkActive]="['active']"
		   [routerLink]="['/user-profile']" class="sidebar-link" fxLayout="row" fxLayoutAlign="start center"
		   mat-button matTooltipPosition="after">
			<mat-icon>account_circle</mat-icon>
			<span>{{'mainNav.userProfileButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'worker' && currentDriver?.canViewManifests" [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.workButton' | translate" [routerLinkActive]="['active']" [routerLink]="['/work']"
		   class="sidebar-link" fxLayout="row" fxLayoutAlign="start center" mat-button
		   matTooltipPosition="after">
			<mat-icon>work</mat-icon>
			<span>{{'mainNav.workButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'worker'" [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.settlementsButton' | translate"
		   [routerLinkActive]="['active']" [routerLink]="['/settlements']"
		   class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>assignment_turned_in</mat-icon>
			<span>{{'mainNav.settlementsButton' | translate}}</span>
		</a>
		<a *ngIf="user?.type === 'worker'" [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.estimatedSettlementsButton' | translate"
		   [routerLinkActive]="['active']" [routerLink]="['/estimated-settlements']"
		   class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>assignment</mat-icon>
			<span>{{'mainNav.estimatedSettlementsButton' | translate}}</span>
		</a>
		<a *ngIf="user?.token" (click)="logout()" [matTooltipDisabled]="!sidebarCollapsed"
		   [matTooltip]="'mainNav.logoutButton' | translate"
		   class="sidebar-link" fxLayout="row"
		   fxLayoutAlign="start center" mat-button matTooltipPosition="after">
			<mat-icon>power_settings_new</mat-icon>
			<span>{{'mainNav.logoutButton' | translate}}</span>
		</a>
	</mat-nav-list>
	<a (click)="toggleSidebarCollapsed()" [matTooltipDisabled]="!sidebarCollapsed"
	   [matTooltip]="sidebarCollapsed ? 'Expand' : 'Collapse'"
	   class="sidebar-link sidebar-collapse-toggle" fxFlexOffset="auto" fxLayout="row" fxLayoutAlign="start center"
	   id="COLLAPSE_SIDEBAR"
	   mat-button matTooltipPosition="after">
		<mat-icon>{{sidebarCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left'}}</mat-icon>
		<span>{{sidebarCollapsed ? 'Expand' : 'Collapse'}}</span>
	</a>
</div>
